/**
 * Use to store instances
 * This is new and we will rework client.js to use it.
 */
export default class DependenciesInjector {
    private static registry: { [key: string]: { construct: any, instance: any, module: Function } } = {};

    /**
     * Will return the reference to instance important will throw error if is not declared
     * @param key
     */
    public static async getRegistered(key: string): Promise<any> {
        const registered = DependenciesInjector.registry[key];

        if (registered) {
            if (registered.instance) {
                return registered.instance;
            } else {
                try {
                    registered.instance = new registered.construct()

                    const moduleLoad = await registered.instance;
                    // check if is lazyload module.
                    if (moduleLoad && moduleLoad[key]) {
                        registered.construct = moduleLoad[key];
                        if (typeof moduleLoad[key] === 'function') {
                            registered.instance = new registered.construct();
                        } else {
                            return registered.instance = moduleLoad[key]
                        }
                    }

                    if (typeof registered.instance.initialize === 'function') {
                        await registered.instance.initialize();
                    }

                    return registered.instance;
                } catch (error) {
                    throw error;
                }
            }
        } else {
            throw new Error(`Error: ${key} was not registered.`);
        }
    }

    /**
     * Will register the instance
     * @param key
     * @param value
     */
    public static register(dependenciesArr: { key: string, construct: any }[], caller: any) {
        // console.log(caller, arguments);
        dependenciesArr.map(el => {
            const registered = DependenciesInjector.registry[el.key];

            if (registered) {
                return;
            }

            DependenciesInjector.registry[el.key] = { construct: el.construct, instance: null, module: caller };
        })
    }


}
